"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
/**
 * @author tatevik.marikyan
 * @since 27/07/2018
 */
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var hierarchical_search_deserialization_service_1 = require("./hierarchical-search-deserialization.service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var from_1 = require("rxjs/observable/from");
var HierarchicalSearchService = /** @class */ (function () {
    function HierarchicalSearchService(applicationPropertiesService, currentLanguageProvider, dataService, kbService, languageService) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.dataService = dataService;
        this.kbService = kbService;
        this.languageService = languageService;
        this.ENTITY_SEARCH_SERVICE_URI_KEY = 'entity-search-service-url';
        this.URL_HIERARCHICAL_ITEMS_LOAD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/hierarchicalentities/", ""], ["", "/hierarchicalentities/", ""])), 'serviceUri', 'rootCategoryName');
        this.entitySearchServiceUri$ =
            from_1.from(this.applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY));
        this.hierarchicalSearchSerializationService =
            new hierarchical_search_deserialization_service_1.HierarchicalSearchDeserializationService(currentLanguageProvider, languageService);
    }
    /**
     * Loads Hierarchical Items in given categories with specified root Category
     * @param {Map<string, string>} categoryFieldsMapping
     * @param {string} rootCategoryName
     * @param {HierarchicalSearchFilterOptions} filter
     * @param {PagingOptions} paging
     * @returns {Observable<any>}
     */
    HierarchicalSearchService.prototype.loadHierarchicalEntities = function (categoryFieldsMapping, rootCategoryName, filter, paging) {
        var _this = this;
        return this.entitySearchServiceUri$.pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_HIERARCHICAL_ITEMS_LOAD.replaceTemplate({
                serviceUri: serviceUri,
                rootCategoryName: rootCategoryName
            });
            var queryParams = [];
            if (paging !== undefined && paging !== null) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('paging', paging));
            }
            queryParams.push(new idm_de_core_frontend_1.SearchParam('filter', filter || {}));
            var hierarchicalEntitiesData$ = _this.dataService.load(url, queryParams);
            return _this.hierarchicalSearchSerializationService.deserializeEntities(hierarchicalEntitiesData$, categoryFieldsMapping);
        }));
    };
    HierarchicalSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_de_service_client_js_1.DataService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService])
    ], HierarchicalSearchService);
    return HierarchicalSearchService;
}());
exports.HierarchicalSearchService = HierarchicalSearchService;
var templateObject_1;
//# sourceMappingURL=hierarchical-search.service.js.map